import EmptyAddressState from './EmptyAddressState';
import AddressItem from './AddressItem';

const AddressManagement = ({ addresses, onAddClick, onEditClick, onDeleteClick }) => {
	const sortedAddresses = [...addresses].sort((a, b) =>
		(a.isDefault === b.isDefault) ? 0 : a.isDefault ? -1 : 1
	);

	return (
		<div className="bg-white rounded-lg shadow-md p-6">
			<div className="flex justify-between items-center mb-6">
				<h1 className="text-2xl font-bold text-yellow-950">My Addresses</h1>
				{/* <button
					onClick={onAddClick}
					className="btn-primary"
				>
					Add New Address
				</button> */}
			</div>

			{sortedAddresses.length > 0 ? (
				<div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
					{sortedAddresses.map(address => (
						<AddressItem
							key={address._id}
							address={address}
							onEdit={onEditClick}
							onDelete={onDeleteClick}
						/>
					))}
				</div>
			) : (
				<EmptyAddressState onAddClick={onAddClick} />
			)}
		</div>
	);
};

export default AddressManagement;